import React, {ReactNode} from 'react';
import AbstractView from '@src/components/_views/AbstractView';
import NowLoadingMessage from '@src/components/NowLoadingMessage/NowLoadingMessage';

const Calendar = React.lazy(() => import('./calendar/tui/Calendar'));

export default class OrdersCalendar extends AbstractView {
    static pageTitle = 'OrdersCalendar.page-title';

    protected renderContent(): ReactNode {
        return <div className="card">
            <div className="card-body">
                <React.Suspense fallback={<NowLoadingMessage/>}>
                    <Calendar/>
                </React.Suspense>
            </div>
        </div>;
    }
}
